import { Component, OnInit } from '@angular/core';
import { GlobalService } from '../global.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-slots',
  templateUrl: './slots.component.html',
  styleUrls: ['./slots.component.css']
})
export class SlotsComponent implements OnInit {
  DoctorSlots;
  SlectedSlots;
  SelectedDoctor;
  SelectedHospital;

  constructor(private globalService: GlobalService, private router: Router) { }

  ngOnInit() {
     
    this.DoctorSlots = this.globalService.getData();
    this.SelectedHospital = this.globalService.getHospitalInfo();
    this.SelectedDoctor = this.globalService.getDoctorInfo();
    console.log(JSON.stringify(this.DoctorSlots));

  }

  BookSlots(Item: any): void {
    this.SlectedSlots = Item;  
  }

  ContinueToBookAppointment() {
    this.globalService.setHospitalInfo(this.SelectedHospital);
    this.globalService.setDoctorInfo(this.SelectedDoctor);
    this.globalService.setSlecetdSolts(this.SlectedSlots);
    this.globalService.setData(this.DoctorSlots);
    this.router.navigate(['/Book']);
    
  }

}



// WEBPACK FOOTER //
// ./src/app/slots/slots.component.ts